import script from "./ProductSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductSelector.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__